<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心</el-breadcrumb-item
        >
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/baseContent/indexPartList' }"
          >模块列表</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span class="text-primary">编辑模块内容</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>

    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">编辑模块内容</span>
      </div>
      <div
        style="height: 470px;overflow-y: auto;padding-right: 60px"
        v-loading="loading"
      >
        <el-form
          label-width="120px"
          class="font-weight-bold"
          :model="indexPart"
        >
          <el-form-item label="模块名称">
            <el-input v-model="indexPart.partName"></el-input>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-radio-group v-model="indexPart.state">
              <el-radio :label="1" border>显示</el-radio>
              <el-radio :label="0" border>隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitIndexPartForm(indexPart)"
              >立即修改</el-button
            >
            <el-button @click="findNavigationById()">重置 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
export default {
  name: "EditIndexPart",
  data() {
    return {
      partId: this.$route.params.partId,
      indexPart: {},
      loading: false
    };
  },
  mounted() {
    this.getPartById();
  },
  methods: {
    submitIndexPartForm(indexPart) {
      this.axios
        .post("/indexPart/updateById", {
          partId: indexPart.partId,
          partName: indexPart.partName,
          state: indexPart.state
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "IndexPartList" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    },
    getPartById() {
      this.loading = true;
      this.axios
        .get("/indexPart/getPartById", {
          params: {
            partId: this.partId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.indexPart = resp.data.data;
            this.loading = false;
          }
        });
    }
  }
};
</script>

<style scoped></style>
